import { Client, Account, Databases, Storage, ID, Messaging, Functions } from 'appwrite';

// Initialize the Appwrite client
const client = new Client()
    .setEndpoint('https://fra.cloud.appwrite.io/v1')  // Your Appwrite endpoint
    .setProject('683566a7000250cec655');              // Your project ID - main project

// Initialize services
export const account = new Account(client);
export const databases = new Databases(client);
export const storage = new Storage(client);
export const messaging = new Messaging(client);
export const functions = new Functions(client);
export { ID };

// Session storage keys
const SESSION_KEY = 'appwrite_session';
const USER_KEY = 'currentUser';

// Helper function to check authentication
export const checkAuth = async () => {
    try {
        // Check if we have a stored session
        const storedSession = localStorage.getItem(SESSION_KEY);
        if (!storedSession) {
            return false;
        }

        // Verify the session with Appwrite
        const session = await account.getSession('current');
        if (!session) {
            // Clear invalid session data
            localStorage.removeItem(SESSION_KEY);
            localStorage.removeItem(USER_KEY);
            return false;
        }

        // Check if session is expired
        const sessionData = JSON.parse(storedSession);
        const now = new Date().getTime();
        if (sessionData.expiresAt && now > sessionData.expiresAt) {
            // Session expired, clear it
            localStorage.removeItem(SESSION_KEY);
            localStorage.removeItem(USER_KEY);
            return false;
        }

        return true;
    } catch (error) {
        console.error('Auth check failed:', error);
        // Clear any invalid session data
        localStorage.removeItem(SESSION_KEY);
        localStorage.removeItem(USER_KEY);
        return false;
    }
};

// Helper function to ensure authentication
export const ensureAuth = async () => {
    try {
        const isAuthenticated = await checkAuth();
        if (!isAuthenticated) {
            throw new Error('Not authenticated. Please log in.');
        }
        return true;
    } catch (error) {
        console.error('Authentication failed:', error);
        throw new Error('Authentication failed. Please try logging in again.');
    }
};

// Helper function to store session data
export const storeSession = (session: any, user: any) => {
    try {
        const sessionData = {
            sessionId: session.$id,
            userId: session.userId,
            expiresAt: new Date(session.expire).getTime(),
            createdAt: new Date().getTime()
        };
        
        localStorage.setItem(SESSION_KEY, JSON.stringify(sessionData));
        localStorage.setItem(USER_KEY, JSON.stringify(user));
    } catch (error) {
        console.error('Failed to store session:', error);
    }
};

// Helper function to clear session data
export const clearSession = () => {
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem(USER_KEY);
};

// Helper function to get stored user
export const getStoredUser = () => {
    try {
        const userStr = localStorage.getItem(USER_KEY);
        return userStr ? JSON.parse(userStr) : null;
    } catch (error) {
        console.error('Failed to get stored user:', error);
        return null;
    }
};

// Helper function to check if session exists
export const hasActiveSession = async () => {
    try {
        const session = await account.getSession('current');
        return !!session;
    } catch (error) {
        return false;
    }
};

export const getSchoolLogoUrl = async (): Promise<string> => {
  try {
    const directUrl = 'https://fra.cloud.appwrite.io/v1/storage/buckets/6831d6dd0022cb959e72/files/68456cab00006a0b6c48/view?project=683566a7000250cec655&mode=admin';
    const timestamp = new Date().getTime();
    return `${directUrl}&t=${timestamp}`;
  } catch (error) {
    console.error('Error getting school logo:', error);
    return ''; // Return empty string if logo not found
  }
};